import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser'
import { CreateSurveyComponent } from './create-survey.component';
import { SearchInteriorModule } from 'src/app/components/search-interior/search-interior.module';
import { FormsModule } from "@angular/forms";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';
import { SortV2Module } from 'src/app/components/sort-v2/sort-v2.module';
import { AppPaginationModule } from 'src/app/components/pagination/pagination.module';
import { SearchCoreModule } from '../search-core/search-core.module';
import { SearchCoreChipDisplayModule } from '../search-core-chip-display/search-core-chip-display.module';
import { FooterModule } from '../footer/footer.module';
import {LoaderModule} from "src/app/components/loader/loader.module";
import { ButtonModule } from '@xref/xref-lib';



@NgModule({
  declarations: [CreateSurveyComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BsDropdownModule.forRoot(),
    BrowserAnimationsModule,
    SearchInteriorModule,
    PopoverModule.forRoot(),
    TooltipModule.forRoot(),
    TooltipEllipsifyModule,
    SortV2Module,
    SearchCoreModule,
    SearchCoreChipDisplayModule,
    AppPaginationModule,
    FooterModule,
    LoaderModule,
    ButtonModule
  ],
  exports: [CreateSurveyComponent]
})
export class CreateSurveyModule { }
